import React, { useEffect, useState } from 'react'
import UserLayout from '../../../components/layouts/UserLayout'
import StudentOverviewCard from '../../../components/partials/students/StudentOverviewCard'
import { authHeader } from '../../../utils';
import axios from 'axios';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ERROR } from '../../../store/types';
import Loader from '../../../components/elements/Loader';
import StudentOverview from '../../../components/partials/students/StudentOverview';
import StudentDetails from '../../../components/partials/students/StudentDetails';
import StudentAcademics from '../../../components/partials/students/StudentAcademics';
import StudentClassSchedule from '../../../components/partials/students/StudentClassSchedule';
import StudentDisciplinary from '../../../components/partials/students/StudentDisciplinary';
import StudentFeedback from '../../../components/partials/students/StudentFeedback';
import { fetchDocumentRequests } from '../../../store/actions/documentRequestActions';
import StudentMedicals from '../../../components/partials/students/StudentMedicals';
import StudentInvoices from '../../../components/partials/students/StudentInvoices';
import StudentSundry from '../../../components/partials/students/StudentSundry';
import StudentExeatsCheckIns from '../../../components/partials/students/StudentExeatsCheckIns';
import MobileStudentTabs from '../../../components/elements/MobileStudentTabs';
import InlinePreloader from '../../../components/elements/InlinePreloader';
import ArrowDownTrayIcon from '../../../components/elements/icons/ArrowDownTrayIcon';

const Student = () => {
  const { studentId } = useParams()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true);
  const [studentDetails, setStudentDetails] = useState(null);
  const [reload, setReload] = useState(0);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if(searchParams.get('activeTab')){
      setActiveTabIndex(studentTabs.findIndex(tab => tab.value === searchParams.get('activeTab')))
    }
    dispatch(fetchDocumentRequests(`student=${studentId}`))
    const fetchStudents = async () => {
      try {
        const headers = authHeader()

          const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/students/${studentId}?expand=class.class,class.division,admissionOffer`, { headers })            

          setStudentDetails(response.data.data)
          setLoading(false)
        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setLoading(false)
        }
    }

    fetchStudents()

    return () => {
      
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentId, dispatch, reload]);
  
  const studentTabs = [
    {
      label: "Overview",
      value: 'overview'
    },
    {
      label: "Student Details",
      value: 'details'
    },
    {
      label: "Medicals",
      value: 'medicals'
    },
    {
      label: "Academics",
      value: 'academics'
    },
    {
      label: "Sundry",
      value: 'sundry'
    },
    {
      label: "Invoices",
      value: 'invoices'
    },
    {
      label: "Exeats",
      value: 'exeats'
    },
    {
      label: "Disciplinary Records",
      value: 'disciplinary'
    },
    {
      label: "Feedback",
      value: 'feedback'
    },
  ]

  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const changeTab = (tabIndex) => {
    setActiveTabIndex(tabIndex)
  }

      const [savingPdf, setSavingPdf] = useState(false)

  // download application as pdf
  const downloadStudentData = async () => {
    try {
      const headers = authHeader()
      setSavingPdf(true)

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/students/${studentId}/export/pdf`,
        { 
          headers,
          responseType: 'blob'
        }
      )
      
      // Create a blob URL
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      
      // Create a temporary link and trigger download
      const link = document.createElement('a')
      link.href = url
      link.download = `student-${studentDetails.admissionNumber}.pdf`
      document.body.appendChild(link)
      link.click()
      
      // Cleanup
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      setSavingPdf(false)

    } catch (error) {
      console.log('error downloading application: ', error)
      dispatch({
        type: ERROR,
        error
      })
      setSavingPdf(false)

    }
  }


  return (
    <UserLayout>
      <div className='w-full py-2 lg:py-8'>
        {loading ? 
          <Loader />
          :
          <div className='xl:flex items-start gap-x-8'>
            <div className='w-full xl:w-[300px] xl:sticky xl:top-[50px]'>
              <StudentOverviewCard student={studentDetails} />
            </div>
            <div className='w-full mt-6 lg:mt-0'>
              <div className='w-full'>
                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Admission number</label>
                <div className='flex items-center gap-x-2'>
                  <h3 className='font-medium font-orbitron'>{studentDetails.admissionNumber}</h3>
                  <div className='flex items-center gap-x-[5px]'>
                    
                    {<button onClick={downloadStudentData} disabled={savingPdf} className='rounded-[8px] w-[30px] h-[30px] text-sm text-gray-600 bg-transparent transition duration-200 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2'>
                      {savingPdf 
                        ?
                          <InlinePreloader />
                        :
                          <ArrowDownTrayIcon className='w-4 h-4' />
                      }

                    </button>}
                    {/* <button onClick={()=>{setRejectingApplication(true)}} className='rounded-[8px] w-[30px] h-[30px] text-sm text-gray-600 bg-transparent transition duration-200 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2'>
                      <PrinterIcon className='w-4 h-4' />
                    </button> */}
                    
                  </div>
                </div>
              </div>
              <div className='w-full xl:hidden mt-[20px]'>
                <h3 className='text-sm text-gray-600 font-medium mb-[5px]'>Navigation</h3>
                <p className='text-xs text-gray-500 mb-[10px]'>Click on the tab below to navigate through more details on this student</p>
                <MobileStudentTabs tabs={studentTabs} doSelect={(index)=>{setActiveTabIndex(index)}} />
              </div>
              <div className='w-full hidden xl:flex items-center'>
                {studentTabs.map((tab, tabIndex)=>(
                  <button key={tabIndex} 
                    className={`py-2 px-5 rounded-t-[8px] transition duration-200 hover:border-gray-400 text-sm hover:text-vcm-purple ${activeTabIndex === tabIndex ? 'border-b-2 border-vcm-purple text-vcm-purple bg-vcm-light-purple bg-opacity-10' : 'border-b border-gray-200 text-gray-400'}`}
                    onClick={()=>{changeTab(tabIndex)}}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              <div className='py-8'>
                {studentTabs[activeTabIndex]?.value === 'overview' && <>
                  <StudentOverview student={studentDetails}  />
                </>}

                {studentTabs[activeTabIndex]?.value === 'details' && <>
                  <StudentDetails student={studentDetails} reload={()=>{setReload(prev => prev + 1)}} setReload={setReload} />
                </>}

                {studentTabs[activeTabIndex]?.value === 'medicals' && <>
                  <StudentMedicals student={studentDetails} reload={()=>{setReload(prev => prev + 1)}} setReload={setReload} />
                </>}

                {studentTabs[activeTabIndex]?.value === 'invoices' && <>
                  <StudentInvoices student={studentDetails} reload={()=>{setReload(prev => prev + 1)}} setReload={setReload} />
                </>}

                {studentTabs[activeTabIndex]?.value === 'academics' && <>
                  <StudentAcademics student={studentDetails} />
                </>}

                {studentTabs[activeTabIndex]?.value === 'schedule' && <>
                  <StudentClassSchedule />
                </>}

                {studentTabs[activeTabIndex]?.value === 'exeats' && <>
                  <StudentExeatsCheckIns student={studentDetails} />
                </>}

                {studentTabs[activeTabIndex]?.value === 'disciplinary' && <>
                  <StudentDisciplinary student={studentDetails} />
                </>}

                {studentTabs[activeTabIndex]?.value === 'feedback' && <>
                  <StudentFeedback student={studentDetails} />
                </>}

                {studentTabs[activeTabIndex].value === 'sundry' && <>
                  <StudentSundry student={studentDetails} />
                </>}

              </div>

            </div>

          </div>
        }
      </div>
    </UserLayout>
  )
}

export default Student